module.exports = __webpack_public_path__ + "img/motorcycle-none-left.15ab2df3.jpg";